module.exports = __webpack_public_path__ + "img/findthispixelanomaly.9b50ef53.jpg";